import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { resetFilter } from "../features/filter/filterSlice";
import { fetchTransactions } from "../features/transaction/transactionSlice";

import LoadingSpinner from "./LoadingSpinner";
import Transaction from "./Transaction";

const Transactions = () => {
  const dispatch = useDispatch();
  const { transactions, loading, error } = useSelector((state) => state.transaction);
  const { isLoading, loadingType } = loading;
  const { isError, errorType, errorMsg } = error;
  const filter = useSelector((state) => state.filter);
  console.log(isLoading && loadingType === "fetchTransactions");
  useEffect(() => {
    dispatch(resetFilter());
    dispatch(fetchTransactions({ ...filter, limit: 5 }));
  }, [dispatch, filter]);

  return (
    <>
      <p className='second_heading'>Your Transactions:</p>
      <div className='conatiner_of_list_of_transactions'>
        <ul>
          {isLoading && loadingType === "fetchTransactions" ? (
            <div className='loading-container'>
              <LoadingSpinner color='dark' size='lg' />
            </div>
          ) : isError && errorType === "fetchError" ? (
            <p className='error'>{errorMsg}</p>
          ) : transactions.length > 0 ? (
            transactions.map((transaction) => <Transaction transaction={transaction} key={transaction.id} />)
          ) : (
            <p>No Transaction Found</p>
          )}

          {transactions.length > 0 && (
            <Link to='/transactions'>
              <button className='show-all'>Show All</button>
            </Link>
          )}
        </ul>
      </div>
    </>
  );
};

export default Transactions;
